import Icon from '../components/Icon.vue'

Icon.register({
  equals: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M416 304c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32h-384c-17.7 0-32-14.3-32-32v-32c0-17.7 14.3-32 32-32h384zM416 112c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32h-384c-17.7 0-32-14.3-32-32v-32c0-17.7 14.3-32 32-32h384z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/equals.js
// module id = 1301
// module chunks = 0